import { render, staticRenderFns } from "./ValuesEditor.vue?vue&type=template&id=7874ca14&"
import script from "./ValuesEditor.vue?vue&type=script&setup=true&lang=js&"
export * from "./ValuesEditor.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports